import { body } from 'express-validator'

export const validateRegister = [
  body('username').trim().isLength({ min: 3 }).escape(),
  body('password').trim().isLength({ min: 6 }).escape(),
  body('email').isEmail().normalizeEmail(),
  body('name').trim().isLength({ min: 3 }).escape(),
  body('address').trim().isLength({ min: 3 }).escape(),
  body('phone').trim().isLength({ min: 3 }).optional().escape(),
  body('mobile').trim().isLength({ min: 3 }).escape(),
  body('role').trim().isLength({ min: 3 }).escape(),
  body('city').trim().isLength({ min: 3 }).escape(),
  body('reference').trim().isLength({ min: 0 }).escape().optional(),
  body('notes').trim().isLength({ min: 0 }).escape().optional(),
]
